import type { KeyboardEvent } from 'react';

export const onEnterPressHandler = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === 'Enter') {
    const { value: searchQuery } = e.target as HTMLInputElement;
    window.location.href = `/search?query=${encodeURIComponent(searchQuery)}`;
  }
};
